<template>
    <div>
        <section class="form-section">
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="can_buy_licenses">
                         {{ trans('clients.label.can_buy_licenses') }}
                    </label>
                    <select name="can_buy_licenses" class="form-select" v-model="fields.canBuyLicenses" id="can_buy_licenses">
                        <option disabled>{{ trans('clients.label.select') }}</option>
                        <option value="1">{{ trans('form.yes') }}</option>
                        <option value="0">{{ trans('form.no') }}</option>
                    </select>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="expiration_period"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.expirationPeriod"
                    >
                        {{ trans('licenses.label.expiration_period') }}
                    </form-input>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'license',
        'client',
    ],

    data() {
        return {
            fields: {
                expirationPeriod: this.old('expiration_period', this.license.expiration_period),
                canBuyLicenses: this.old('can_buy_licenses', this.license.can_buy_licenses),
            },
        };
    },
}
</script>
